var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgressCircleDone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.5,
    fill: "white",
    stroke: "#00984C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6869 7.85355C13.8821 7.65829 13.8821 7.34171 13.6869 7.14645C13.4916 6.95118 13.175 6.95118 12.9798 7.14645L13.6869 7.85355ZM8.75 12.0833L8.39645 12.4369C8.49022 12.5307 8.61739 12.5833 8.75 12.5833C8.88261 12.5833 9.00979 12.5307 9.10355 12.4369L8.75 12.0833ZM7.02022 9.64645C6.82496 9.45118 6.50838 9.45118 6.31311 9.64645C6.11785 9.84171 6.11785 10.1583 6.31311 10.3536L7.02022 9.64645ZM12.9798 7.14645L8.39645 11.7298L9.10355 12.4369L13.6869 7.85355L12.9798 7.14645ZM9.10355 11.7298L7.02022 9.64645L6.31311 10.3536L8.39645 12.4369L9.10355 11.7298Z",
    fill: "#00984C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressCircleDone);
export default __webpack_public_path__ + "static/media/progress-circle-done.a51aadf17a181eb6df5072d0bf94049b.svg";
export { ForwardRef as ReactComponent };